import { useState } from "react";
import CheckboxWithLabel from "./CheckboxWithLabel";
import { makeStyles } from "@material-ui/core/styles";
import { List, Menu, IconButton, Box, Tooltip } from "@material-ui/core";
import Fade from "@material-ui/core/Fade";
import SettingsIcon from "@material-ui/icons/Settings";
import PropTypes from "prop-types";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    justifyContent: "center",
  },
  MenuList: {
    paddingTop: 0,
    paddingBottom: 0,
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    alignContent: "flex-start",
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  hover: {
    "&:hover": {
      color: "#d9833b",
    },
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

const TableColumnShowHide = ({
  headers = [],
  handleShowColumn = () =>
    alert("No handleShowColumn function passed to TableColumnShowHide"),
  showClose = false,
  onCloseHandler = () =>
    alert("No onCloseHandler function passed to TableColumnShowHide"),
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box position="absolute" style={{ right: "0" }}>
      <Tooltip title={"Show/Hide Columns"}>
        <IconButton
          onClick={handleClick}
          aria-label="delete"
          className={classes.margin}
          size="small"
        >
          <SettingsIcon
            style={{ color: props => (props.nightMode ? "white" : "#303e4f") }}
            fontSize="large"
            fontWeight="lighter"
          />
        </IconButton>
      </Tooltip>
      {showClose && (
        <IconButton
          onClick={onCloseHandler}
          aria-label="delete"
          className={classes.margin}
          size="small"
        >
          <CloseIcon style={{ color: "white" }} fontSize="inherit" />
        </IconButton>
      )}
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        // keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            overflow: "auto",
            maxHeight: "20vh",
          },
        }}
        classes={{ list: classes.MenuList }}
        data-cy="user-options-menu"
        TransitionComponent={Fade}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        getContentAnchorEl={null}
      >
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          className={classes.root}
          classes={{ padding: classes.MenuList }}
          data-cy="user-options-menu-list"
        >
          {headers.map(column => {
            return (
              <CheckboxWithLabel
                formStyle={""}
                checked={column?.show}
                onChange={handleShowColumn}
                stateName={column.idName}
                title={column.title}
                key={column.idName}
                disabled={false}
              />
            );
          })}
        </List>
      </Menu>
    </Box>
  );
};

export default TableColumnShowHide;

TableColumnShowHide.propTypes = {
  headers: PropTypes.array,
  handleShowColumn: PropTypes.func,
  showClose: PropTypes.bool,
  onCloseHandler: PropTypes.func,
};
